import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/appConfig/useAppConfigQueryKeys.ts
var t = e("app-config", { features: () => ["features"] });
//#endregion
export { t as appConfigQueryKeys };
